const processType = {
  Schadegarant: 'schadegarant',
  DealerSaas: 'dealer_saas',
  IntakePlus: 'intake_plus',
};

export default processType;
